var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "162px",
    height: "163px",
    viewBox: "0 0 162 163",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 148 0 148 16.0839844 15.078125 16.0839844 15.078125 148 0 148"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    width: 7.13731374,
    height: 7.13731374,
    x: -7.13731374,
    y: -7.13731374,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-3",
    transform: "scale(0.142746275,0.142746275)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-3",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABGdBTUEAALGN5fIAKQAAAY1JREFUaAXtl0duw0AMRX2J9O6a3px2/yOkd6f3eoLkMfAiBjiz0Eb4TAgQhjiQ9d88WZArX711yWG1oli9HD9HV5IwDoiNDKYmJYbAd5bcqWtmdRkYwrboHIyOGUCa9C3tlZyZHMwNhFK3WYPAKTMG01D6zRiMhfbKIKVg6gTOwTSVzISDsaeWV/bIbimZqRE4FIy9tnh1z3BayUyVwH8GZkbJzBRm7H+LVw8MQ8HMKpmZZPcvPC3MzEwYmEdg5tTMdAjtlRzMBBQdj4RZKJgngOaVbrNxAp8nzISDWVAzc5Yw88xcCmaMwDmYRSUzBnOaMbOkBDOagXlhLRTMspqZk8RtZmakYEYInIJ5ZW1FyYzBHNNeycEMQ5GDWVUyYzBHnhZmb3QomLaSmSF2/zBjJgzMO5BrSmYGCXyQMBMOZl3NzH7CzAdzKZgBAudgNpTMGMxexszmP0wZO4CR/oyZT9a2yshV6JpdmF0+vYoFU2iHyjoJHX30jqelrEyFr5uCKfyFZZ7Yhdn+beYb9CNZC1e1TTcAAAAASUVORK5CYII="
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "index_1",
    transform: "translate(-54.000000, -46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(54.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.28,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#pattern-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fillOpacity: 0.300152972,
    fill: "#FFFFFF",
    x: 15,
    y: 16,
    width: 146,
    height: 146
  }), /*#__PURE__*/React.createElement("text", {
    id: "White-Space",
    fontFamily: "NotoSansCJKtc-Medium, Noto Sans CJK TC",
    fontSize: 31,
    fontWeight: 400,
    "line-spacing": 44,
    letterSpacing: 3.23777795,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    y: 77
  }, "White"), /*#__PURE__*/React.createElement("tspan", {
    x: 41,
    y: 121
  }, "Space")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.b03bba7e.svg";
export { ForwardRef as ReactComponent };